import React from 'react';

import { cn } from '@/utils/classname';

export interface SettingRowProps {
  /** Row content - supports any layout structure */
  children: React.ReactNode;
  /** Additional className for customization */
  className?: string;
  /** Remove vertical padding (useful for nested layouts) */
  noPadding?: boolean;
  /** Test ID for E2E testing */
  'data-testid'?: string;
}

/**
 * Standardized row container for Linear-style settings with automatic divider support.
 *
 * Designed for use within SettingContentCard with divide-y to create
 * automatic dividers between rows. Provides consistent padding (py-6)
 * with first-child padding removal (first:pt-0) for clean spacing.
 *
 * Padding System:
 * - Default: py-6 (24px vertical) with first:pt-0 (removes top padding from first row)
 * - noPadding: Removes all padding for custom layouts
 * - Matches SettingContentCard spacing when padding="lg"
 */
export const SettingRow: React.FC<SettingRowProps> = ({
  children,
  className,
  noPadding = false,
  'data-testid': testId,
}) => {
  return (
    <div
      className={cn(!noPadding && 'py-6 first:pt-0', className)}
      data-testid={testId}
    >
      {children}
    </div>
  );
};
